import * as React from "react";
import { forwardRef } from "react";
const SvgRightOutlined = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 6 9",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M0.5 1.50361L3.51432 4.5145L0.5 7.52538L1.49284 8.51709L5.5 4.5145L1.49284 0.511902L0.5 1.50361Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgRightOutlined);
export default ForwardRef;
